import { useEffect } from 'react';

/**
 * Binds Cmd+K (macOS) / Ctrl+K to the given toggle handler. Prevents the
 * browser's default handling of the combination.
 */
const useCommandPaletteShortcut = (toggle: () => void): void => {
  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      if ((event.metaKey || event.ctrlKey) && event.key.toLowerCase() === 'k') {
        event.preventDefault();
        toggle();
      }
    };

    document.addEventListener('keydown', handleKeyDown);
    return () => document.removeEventListener('keydown', handleKeyDown);
  }, [toggle]);
};

export default useCommandPaletteShortcut;
